import React, { useState, useEffect, useRef } from 'react';
import './PactesStat.css';

const POWER_AUTOMATE_URL = "https://default4a150481463f4fcea393bc23f5987f.58.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/cb0f603005524456a5618a0a183a5573/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=SdS2p4tIeZwHO1L4QCql9GAs0J3nTB9-6Y9QRRrSDps"; 

const fetchPactesData = async () => {
    try {
        const response = await fetch(POWER_AUTOMATE_URL, {
            method: 'GET', 
            headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
        return await response.json(); 
    } catch (error) {
        console.error("Échec de la récupération des données:", error);
        return { Belgique: 0, Flandre: 0, Wallonie: 0, Bruxelles: 0, Provinces: {} };
    }
};

const StatCard = ({ title, count, className = '' }) => (
    <div className={`stat-card ${className}`}>
        <h2 className="card-title">{title}</h2>
        <p className="card-count">{(count ?? 0).toLocaleString('fr-FR')}</p>
    </div>
);

const ProvinceCard = ({ title, provinceData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const cardRef = useRef(null); // Référence pour détecter le clic extérieur

    const total = provinceData?.total ?? 0;
    const rawEcoles = provinceData?.details ?? [];

    // --- LOGIQUE DE FERMETURE AU CLIC EXTÉRIEUR ---
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && cardRef.current && !cardRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    // --- LOGIQUE DE REGROUPEMENT ---
    const groupedEcoles = rawEcoles.reduce((acc, current) => {
        const name = current.Schoolnaam || "Nom inconnu";
        const existing = acc.find(item => item.name === name);
        if (existing) {
            existing.count += 1; 
        } else {
            acc.push({ name: name, count: 1 });
        }
        return acc;
    }, []);

    const sortedEcoles = groupedEcoles.sort((a, b) => b.count - a.count);

    return (
        <div 
            ref={cardRef} 
            className={`stat-card province-card ${isOpen ? 'is-open' : ''}`} 
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="card-header">
                <h2 className="card-title">{title}</h2>
                <p className="card-count">{total.toLocaleString('fr-FR')}</p>
                <span className="toggle-icon">{isOpen ? '▲ Fermer' : '▼ Voir les écoles'}</span>
            </div>

            {isOpen && (
                <div className="ecoles-list-container" onClick={(e) => e.stopPropagation()}>
                    <hr />
                    <ul className="ecoles-list">
                        {sortedEcoles.length > 0 ? (
                            sortedEcoles.map((ecole, index) => (
                                <li key={index} className="ecole-item">
                                    <span className="ecole-name">{ecole.name}</span>
                                    <span className="ecole-value">
                                        {ecole.count} {ecole.count > 1 ? 'pactes' : 'pacte'}
                                    </span>
                                </li>
                            ))
                        ) : (
                            <li className="no-data">Aucune donnée trouvée</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

function PactesStat() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPactesData().then(result => {
            setData(result);
            setLoading(false);
        });
    }, []);

    if (loading) return <div className="pactes-container loading">Chargement des données...</div>;
    if (!data) return <div className="pactes-container error">Erreur de chargement.</div>;

    return (
        <div className="pactes-stat-page">
            <h1>📈 Statistiques des Pactes Signés</h1>
            
            <section className="global-stats">
                <StatCard title="Total Belgique 🇧🇪" count={data.Belgique} className="global-card" />
                <StatCard title="Flandre 🇧🇪" count={data.Flandre} className="regional-card" />
                <StatCard title="Wallonie 🇧🇪" count={data.Wallonie} className="regional-card" />
                <StatCard title="Bruxelles 🇧🇪" count={data.Bruxelles} className="regional-card" />
            </section>
            
            <hr />
            
            <h2>Détail par Province</h2>
            <section className="province-grid">
                {Object.entries(data.Provinces || {}).map(([name, provinceData]) => (
                    <ProvinceCard key={name} title={name} provinceData={provinceData} />
                ))}
            </section>
        </div>
    );
}

export default PactesStat;